import env from '#shared/config/env.js';

import appError from './appError.js';
import json from './json.js';

/**
 * Handle shared error handler
 * @param {object} error
 * @param {object} errorDetails
 */
const uncaughtErrorHandler = (error, errorDetails) => {
	appError(error, {
		code: 'APP_SHARED_UTIL',
		origin: 'uncaughtErrorHandler',
		detail: {
			error: json.stringify(errorDetails ?? {})
		}
	});
};

export default (() => {
	if (env.isLocalhost) { // For better debugging, do not use custom handlers during development
		return;
	}
	if (IS_CLIENT) {
		const uncaughtClientErrorHandler = (message, fileName, lineNumber, columnNumber, error) => {
			uncaughtErrorHandler(error, {
				message,
				fileName,
				lineNumber,
				columnNumber
			});
		};
		window.onerror = uncaughtClientErrorHandler;
	}
	if (IS_SERVER) {
		const uncaughtServerErrorHandler = (error, event = 'warning') => {
			uncaughtErrorHandler(error, {
				event
			});
			process.exit(1);
		};
		process.on('warning', uncaughtServerErrorHandler);
		process.on('uncaughtException', uncaughtServerErrorHandler);
		process.on('unhandledRejection', uncaughtServerErrorHandler);
	}
})();
